import React, { Component } from "react";
import FilterButton from "./FilterButton";

class FilterButtonCollection extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.props.items.map((item) => {
          return (
            <FilterButton
              key={item.value}
              item={item}
              className="c-filter-button c-filter-button--tag"
              onClick={() => this.props.onItemSelected(item)}
            />
          );
        })}
      </div>
    );
  }
}

export default FilterButtonCollection;
